module.exports = __webpack_public_path__ + "static/media/logo-new.3a15507f.svg";